import wixData from 'wix-data';

export function dateFormat(timestamp) {
	let date = new Date(timestamp*1000);
	let day = date.getDate();
	let month = date.toLocaleString('en-us', { month: "short" }).toUpperCase();
	let year = date.getFullYear();
	return `${month} ${day}, ${year}`;
}

export function convertToSlug(string){
    return string
        .toLowerCase()
		.replace(/[^\w\-]+/g, '')
        .replace(/[^\w ]+/g,'')
		.replace(/[^\w ]+/g,'')
        .replace(/ +/g,'-');
}

export function parsePrsXml(xml) {
	let items = [];
	let dates = [];
	let titles = [];
	let files = [];
	let ids = [];
	
	let datesRaw = xml.match(/<released>([^<]*)<\/released>/g);
	let filesRaw = xml.match(/<pdf_url>([^<]*)<\/pdf_url>/g);
	let titlesRaw = xml.match(/<headline>([^<]*)<\/headline>/g);
	let idsRaw = xml.match(/<id>([^<]*)<\/id>/g);
	let count = xml.match(/<matching_count>([^<]*)<\/matching_count>/g);
	count = count.toString().slice(16, -17);
	
	if( count > 0 ) {
		filesRaw.forEach(date => {
			files.push(date.slice(9, -10));
		});

		datesRaw.forEach(date => {
			dates.push(date.slice(10, -11));
		});

		idsRaw.forEach(id => {
			ids.push(id.slice(4, -5));
		});

		titlesRaw.forEach(filing => {
			titles.push(filing.slice(10, -11));
		});
		
		items.push(titles, dates);
		
		var itemsParsed = [];

		titles.forEach( function (item, i) {
			itemsParsed.push({
				_id: ids[i],
				title: titles[i],
				date: dates[i],
				file: files[i]
			});
		});
		
		return itemsParsed;
	}
	return null;
}

// export async function savePrs(items){
// 	let toInsert = {
// 		'recentItemDate': items[0].date,
// 		'xmlDump': JSON.stringify(items)
// 	};

// 	let recentItem = await wixData.query('prCache')
// 		.find()
// 		.then( (results) => {
// 			return results.items[0];
// 		})
// 		.catch( (err) => {
// 			let errorMsg = err;
// 		});
	
// 	if( recentItem.recentItemDate !== items[0].date ){
// 		savePrsToDb(toInsert);	
// 	}
// }

// export function savePrsToDb(toInsert) {
// 	wixData.insert('prCache', toInsert)
// 		.then( (results) => {
// 			console.log('success');
// 		})
// 		.catch( (err) => {
// 			let errorMsg = err;
// 		});
// }